module.exports = __webpack_public_path__ + "static/media/099-albania.42cb2afc.svg";